/* Charm quiz embed — measure header, size iframe to remaining viewport (v6)
   Unpublished draft only. No-ops when .charm-reflection-embed is absent.
*/
(function () {
  function sizeQuizIframe() {
    var wrap = document.querySelector('.charm-reflection-embed');
    if (!wrap) return;
    var iframe = wrap.querySelector('iframe');
    if (!iframe) return;

    var header = document.querySelector('#header-group');
    var headerH = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
    // Fallback if header not ready
    if (headerH < 40) headerH = 120;

    var h = Math.max(320, Math.floor(window.innerHeight - headerH));
    iframe.style.setProperty('height', h + 'px', 'important');
    iframe.style.setProperty('min-height', '0', 'important');
    iframe.style.setProperty('max-height', 'none', 'important');
    iframe.setAttribute('data-charm-quiz-sized', '1');
    document.documentElement.style.setProperty('--charm-quiz-iframe-h', h + 'px');
  }

  function bind() {
    sizeQuizIframe();
    window.addEventListener('resize', sizeQuizIframe);
    // Header fonts / announcement can change height after load
    window.addEventListener('load', sizeQuizIframe);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { sizeQuizIframe(); }).catch(function () {});
    }
    var header = document.querySelector('#header-group');
    if (header && typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(sizeQuizIframe).observe(header);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
